import { SortChangedEvent, SortDef, SortDirection } from 'ag-grid-community';
import { useCallback, useEffect } from 'react';
import { atom, useAtom, useSetAtom } from 'jotai';
import { useKpiColumnDefs } from '../hooks/useFinancialsColumnDefs';

export interface IFinancialsSortState {
  sort?: SortDirection | SortDef;
  colId: 'kpiName' | 'kpiGroupId';
}

export const financialsSortState = atom<IFinancialsSortState[]>([]);

export function useFinancialsSortState() {
  const { kpiGroupDef, kpiNameDef } = useKpiColumnDefs();
  const [sortState, setSortState] = useAtom(financialsSortState);
  const resetSort = useSetAtom(financialsSortState);

  useEffect(() => {
    setSortState([
      { colId: 'kpiGroupId', sort: kpiGroupDef.initialSort },
      { colId: 'kpiName', sort: kpiNameDef.initialSort },
    ]);
  }, [kpiGroupDef.initialSort, kpiNameDef.initialSort, setSortState]);

  const onSortChanged = useCallback(
    (e: SortChangedEvent) => {
      if (e.columns?.some((col) => col.getColId() === 'kpiName' || col.getColId() === 'kpiGroupId')) {
        setSortState(
          e.columns
            .filter((c) => c.getColId() === 'kpiName' || c.getColId() === 'kpiGroupId')
            .map((c) => ({ sort: c.getSort(), colId: c.getColId() as 'kpiName' | 'kpiGroupId' }))
        );
      }
    },
    [setSortState]
  );

  return {
    onSortChanged,
    resetSort: useCallback(() => resetSort([]), [resetSort]),
    sortState,
  };
}
